<template>
  <div class="roleManage">
    <tree-box title="角色管理" other-tree>
      <template slot="tree">
        <div class="tree__title">
          <p>角色列表</p>
          <span class="add" @click="addRoleTree" v-show="menusList.indexOf('ROLE_MANAGE_ADD')!='-1'">+ 新建</span>
        </div>
        <el-input size="large" v-model="rolename" class="findKeyWords" placeholder="请输入关键字" >
          <i slot="prefix" class="el-input__icon el-icon-search"></i
        ></el-input>
        <el-table :data="roleList" :show-header="false"    @current-change="handleCurrentChange">
          <el-table-column prop="roleName">

          </el-table-column>
          <el-table-column align="right">
            <template slot-scope="scope">
              <img src="../img/editIcon.png" @click="desin(scope.row)" style="cursor: pointer;"/>
              <img
                style="margin-left: 18px;cursor: pointer;"
                src="../img/deleteIcon.png"
                @click="deletedata(scope.row)"
                v-show="menusList.indexOf('ROLE_MANAGE_DELETE')!='-1'"
            /></template>
          </el-table-column>
        </el-table>
      </template>
      <template slot="message">
        <h3>角色信息</h3>
        <div class="inputList">
          <div>
            <p><em style="color: rgba(254, 109, 138, 1)">*</em>角色名称</p>
            <el-input style="width: 18vw" size="large" v-model="roledata.roleName" :disabled="isdesin"></el-input>
          </div>
          <div>
            <p><em style="color: rgba(254, 109, 138, 1)">*</em>角色类型</p>
            <el-select style="width: 18vw" v-model=roledata.roleType size="large" :disabled="isdesin">
              <el-option
                v-for="(item,index) in roletypeList"
                :key="index"
                :label="item.roleTypeName"
                :value="item.roleType"
              ></el-option>
            </el-select>
          </div>
          <div>
            <p>角色备注</p>
            <el-input style="width: 18vw" size="large" v-model=roledata.description :disabled="isdesin"></el-input>
          </div>
        </div>
        <h3>角色权限</h3>
        <div class="checkList">
          <div class="check-item" v-for="(item , index) in rolemenuList">
            <check-box :msg="item" :checkindex="index" :dis="isdesin" @checkdata='changecity' >
            </check-box>
          </div>
        </div>
        <div class="btn-group" v-show="!isdesin" v-if="menusList.indexOf('ROLE_MANAGE_MODIFY')!='-1'">
          <el-button size="large" type="primary" @click="uploaddata()" v-if="roledata.roleId">保存</el-button>
          <el-button size="large" type="primary" @click="newdata()" v-else>新增</el-button>
          <el-button size="large" @click="canceldata()">取消</el-button>
        </div>
      </template>
    </tree-box>
  </div>
</template>
<script>
import treeBox from "./components/treeBox";
import Axios from "@/utils/Axios";
import checkBox from "./components/checkBox";
import Vue from "vue";
export default {
  name: "roleManger",
  components: { checkBox, treeBox },
  data() {
    return {
      checkAll: "",
      rolename:"",
      roleId:"",
      roletypeList:[],
      rolemenuList:[],
      menusList:[],
      roletype:"",
      isIndeterminate: true,
      isdesin:true,
      allcheckrole:[],
      currentRow:"",
      roledata:{
        description:"",
        roleId:"",
        roleName:"",
        roleType:"",
      },
      roleList: [
        {
          roleName: "单位管理员",
        },
        {
          roleName: "单位管理员",
        },
        {
          roleName: "单位管理员",
        },
      ],
    };
  },
  methods: {
    handleCurrentChange(val){

      this.desin(val)
    },

    addRoleTree() {
      this.isdesin=false
    this.cleardata()
      this.getrolemenulist()
    },
    canceldata(){
      this.cleardata()
      this.isdesin=true
      this.getrolemenulist()

    },
    cleardata(){

      this.roledata={
        description:"",
        roleId:"",
        roleName:"",
        roleType:"",
      }
      this.allcheckrole=[]
    },
    desin(data){

      if(data.defaulted){

      }else{
        this.isdesin=false
      }
      this.roledata=data

      this.allcheckrole=[]
      this.getrolemenulist(data.roleId)
    },
    deletedata(data){
      let that = this;
      let param = {};
      this.$confirm("确认删除？", '提示', {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: 'warning'
      }).then(() => {
        param.method = "post";
        param.url = "/role/delete";
        param.data = {
          roleId:data.roleId
        }
        Axios.ajax(param).then((res) => {

          if(res.resultCode=='0'){
            that.$message({
              type: 'success',
              message: "删除成功"
            });

            that.getrolelist()
          }else{
            that.$message({
              type: 'error',
              message: res.resultMessage
            });
          }

        })
      })
    },
    handleCheckAllChange(val) {
      this.checkedCities = val ? cityOptions : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.cities.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.cities.length;
    },
    changecity(data){


      for(let i=0;i<this.allcheckrole.length;i++){
        if(this.allcheckrole[i][0]==data[0]){
          this.allcheckrole.splice(i,1);
        }else{
        }
      }

      this.allcheckrole.push(data)
    },
    getrolelist() {
      let that = this;
      let param = {};
      param.method = "post";
      param.url = "/role/getRoles";
      param.data = {
        roleName:this.rolename
      }
      Axios.ajax(param).then((res) => {

        if (res.data) {
          this.roleList=res.data

        }

      })
    },
    getroletypelist() {
      let that = this;
      let param = {};
      param.method = "post";
      param.url = "/role/getRoleTypes";
      param.data = {

      }
      Axios.ajax(param).then((res) => {

        if (res.data) {
          this.roletypeList=res.data

        }

      })
    },
    getrolemenulist(data) {

      let that = this;
      let param = {};
      param.method = "post";
      param.url = "/role/getAllMenuTree";
      param.data = {
        roleId:data
      }
      Axios.ajax(param).then((res) => {

        if (res.data) {
          this.rolemenuList=res.data
          for(let i=0;i<res.data.length;i++){
            let nowlist=[]
            if(res.data[i].authorization){
              nowlist.push(res.data[i].menuId)
            }

            if(res.data[i].children){
              for(let j=0;j<res.data[i].children.length;j++){
                if(res.data[i].children[j].authorization){
                  nowlist.push(res.data[i].children[j].menuId)

                }
              }
            }
            this.allcheckrole.push([i,nowlist])
          }

        }

      })
    },

    uploaddata(){
      let menuIds=[]

      for(let i=0;i<this.allcheckrole.length;i++){
        for(let j=0;j<this.allcheckrole[i][1].length;j++){
          menuIds.push(this.allcheckrole[i][1][j])
        }
      }

      let that = this;
      let param = {};
      param.method = "post";
      param.url = "/role/update";
      param.data = {
        "description":this.roledata.description,
        "menuIds": menuIds,
        "roleId": this.roledata.roleId,
        "roleName": this.roledata.roleName,
        "roleType":this.roledata.roleType
      }
      Axios.ajax(param).then((res) => {

        if (res.resultCode=='0') {
          this.cleardata()
          this.isdesin=true
          this.$message.success("修改成功！");
        } else {
          this.$message.warning(res.resultMessage);
        }

      })
    },
    newdata(){
      let menuIds=[]
      for(let i=0;i<this.allcheckrole.length;i++){
        for(let j=0;j<this.allcheckrole[i][1].length;j++){
          menuIds.push(this.allcheckrole[i][1][j])
        }

      }

      let that = this;
      let param = {};
      param.method = "post";
      param.url = "/role/add";
      param.data = {
        "description":this.roledata.description,
        "menuIds": menuIds,
        "roleName": this.roledata.roleName,
        "roleType":this.roledata.roleType
      }
      Axios.ajax(param).then((res) => {

        if (res.resultCode=='0') {
          this.cleardata()
          this.isdesin=true
          that.getrolelist()
          this.$message.success("新增成功！");
        } else {
          this.$message.warning(res.resultMessage);
        }

      })
    },
  },
  mounted() {
    this.menusList=Vue.prototype.menusList

    this.getrolelist()
    this.getroletypelist()
    this.getrolemenulist()
  },
  watch:{
    rolename(){
      this.getrolelist()
    }
  }
};
</script>

<style lang="less" scoped>
.roleManage {
  .tree {
    &__title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .add {
        cursor: pointer;
        color: #2a62ff;
      }
    }
    .findKeyWords {
      margin: 26px 0 16px 0;
    }
  }
  .message {
    h3 {
      margin-bottom: 32px;
      padding: 0 10px;
      border-left: 2px solid #2a62ff;
    }
    .inputList {
      margin-bottom: 44px;
      display: flex;
      justify-content: space-between;
      p {
        margin-bottom: 16px;
      }
    }
    .checkList {
      max-height: 425px;
      overflow: auto;
      .check-item{
        display: inline-block;
        margin-right: 20px;
        vertical-align: top;
        margin-bottom:20px;
      }
    }
    .btn-group {
      margin-top: 44px;
    }
    .btn-group button:first-child {
      margin-right: 40px !important;
    }
  }
}
</style>
